import { render, staticRenderFns } from "./AppointmentTypes.vue?vue&type=template&id=1d3e42e6&scoped=true&"
import script from "./AppointmentTypes.vue?vue&type=script&lang=js&"
export * from "./AppointmentTypes.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTypes.vue?vue&type=style&index=0&id=1d3e42e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e42e6",
  null
  
)

export default component.exports